import React from 'react';
import Section from './Section';
var StopsView = function (_a) {
    var upcomingStops = _a.upcomingStops, color = _a.color;
    var displayedStops = upcomingStops.slice(0, 3).reverse();
    var hasMore = upcomingStops.length > displayedStops.length;
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', alignSelf: 'flex-end' } },
        hasMore && (React.createElement(Section, { color: color, line: "arrow", style: { marginTop: -28 } })),
        displayedStops.map(function (stop, i) {
            var first = i === displayedStops.length - 1;
            return (React.createElement(Section, { color: color, key: i, line: i === 0 && !hasMore ? 'terminate' : 'full', stopPosition: first ? 43 : 36 },
                React.createElement("div", { style: first ?
                        { fontSize: 72, color: 'black', marginBottom: 106 } :
                        { fontSize: 60, color: '#585858', marginBottom: 52 } }, stop)));
        })));
};
export default StopsView;



//////////////////
// WEBPACK FOOTER
// ./src/pages/MonitorDisplay/StopsView.tsx
// module id = 1845
// module chunks = 0